import * as Yup from "yup";
import PaymentStatus from "../enums/PaymentStatus";
import ContactType from "../enums/ContactType";
import PaymentPaymentTypes from "../enums/PaymentPaymentTypes";
const { generateCustomFieldsValidation } = require("./customFieldValidations");

const today = new Date();
today.setHours(0, 0, 0, 0);

const paymentValidation = Yup.object().shape({
  dueDate: Yup.date().nullable(),
  scheduledPaymentDate: Yup.date()
    .required("Payment date is required")
    .min(today, "Payment date cannot be in the past"),
  actualPaymentDate: Yup.date().nullable(),
  payTo: Yup.object().shape({
    id: Yup.string().required("Pay to field is required"),
    name: Yup.string(),
    email: Yup.string().email().nullable(),
    type: Yup.mixed().oneOf(Object.values(ContactType)).nullable(),
  }),
  amount: Yup.number()
    .required("Amount is required")
    .min(0.01, "Amount must be greater than 0"),
  currency: Yup.string().required(),
  paymentMethod: Yup.mixed()
    .oneOf(Object.values(PaymentPaymentTypes))
    .required("Payment method is required"),
  status: Yup.mixed().oneOf(Object.values(PaymentStatus)).nullable(),
  notes: Yup.string().nullable(),
  attachments: Yup.array().of(
    Yup.object().shape({
      id: Yup.string(),
      assetUrl: Yup.string().nullable(),
      extension: Yup.string().nullable(),
      file: Yup.mixed().nullable(),
    }),
  ),
});

// Function to dynamically add custom fields to the base schema
const generatePaymentValidationSchema = (customFieldSettings = []) => {
  const customFieldsSchema =
    generateCustomFieldsValidation(customFieldSettings);
  return paymentValidation.concat(
    Yup.object({
      customFields: customFieldsSchema,
    }),
  );
};

export { paymentValidation, generatePaymentValidationSchema };
